'use client';

import * as React from 'react';
const usePreviousProps = value => {
  const ref = React.useRef({});
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
export default usePreviousProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/node_modules/@mui/utils/usePreviousProps/usePreviousProps.js
// module id = 13106
// module chunks = 0